import { currentTimeZone as currentTimeZone_1, toShortTimeString as toShortTimeString_1 } from "./Date.js";
import { empty as empty_1, append as append_1, tryHead, collect, sortBy, groupBy, singleton as singleton_1, head, cons, length, ofArray, ofSeq, mapIndexed, last, map } from "../.fable/fable-library.3.1.4/List.js";
import { compare, equals as equals_1, dayOfWeek, day, month, year, create, dayOfYear, parse } from "../.fable/fable-library.3.1.4/Date.js";
import { isNullOrWhiteSpace, join, printf, toText, replace } from "../.fable/fable-library.3.1.4/String.js";
import * as react from "react";
import { Helpers_nothing } from "../.fable/Fable.React.8.0.1/Fable.React.Helpers.fs.js";
import { Model__IstSubscribed_2297AD2E, Tab, Msg } from "./Types.fs.js";
import { dateHash, stringHash, comparePrimitives, equals, int32ToString } from "../.fable/fable-library.3.1.4/Util.js";
import { empty, singleton, append, delay } from "../.fable/fable-library.3.1.4/Seq.js";
import { map as map_1, defaultArg } from "../.fable/fable-library.3.1.4/Option.js";
import { FSharpMap__get_Item, toList, isEmpty, tryFind } from "../.fable/fable-library.3.1.4/Map.js";
import { DOMAttr, HTMLAttr, DangerousHtml } from "../.fable/Fable.React.8.0.1/Fable.React.Props.fs.js";
import { keyValueList } from "../.fable/fable-library.3.1.4/MapUtil.js";
import { fableModule } from "../Global.fs.js";
import { Deutsch, Englisch } from "./Lokalisierung.fs.js";

export const toShortTimeString = toShortTimeString_1;

export const currentTimeZone = currentTimeZone_1;

export function zeitAusgeben(zeiten, res, inOrtsZeit) {
    return map((d) => {
        let s_1, s;
        const utc = parse(d + (inOrtsZeit ? "Z" : ""));
        const local = parse(d);
        const daydiff = (dayOfYear(utc) - dayOfYear(local)) | 0;
        return replace((s_1 = (s = toShortTimeString(utc, res.Locale), (s.length === 7) ? ("0" + s) : s), (daydiff === 0) ? s_1 : ((daydiff < 0) ? toText(printf("%s %i%s"))(s_1)(daydiff)(res.TagKurz) : toText(printf("%s +%iD"))(s_1)(daydiff))), " ", " ");
    }, zeiten);
}

export function zeitAusgeben$0027(zeiten, res, inOrtsZeit) {
    return react.createElement(react.Fragment, {}, ...map((e) => react.createElement("div", {}, e), zeitAusgeben(zeiten, res, inOrtsZeit)));
}

export function subscriptionStars(eigenesProgramm, subscribed) {
    if (eigenesProgramm) {
        return react.createElement("i", {
            className: "fa " + ((subscribed.tag === 2) ? "fa-star-half-o" : ((subscribed.tag === 1) ? "fa-star-o" : "fa-star")),
        });
    }
    else {
        return Helpers_nothing;
    }
}

function Dialog_toggleSubscription(subscribed, res, dispatch) {
    return react.createElement("button", {
        type: "button",
        className: "btn btn-warning btn-sm",
        onClick: (_arg1) => {
            dispatch(new Msg(7));
        },
    }, react.createElement("i", {
        className: "fa " + ((subscribed.tag === 2) ? "fa-star" : ((subscribed.tag === 1) ? "fa-star" : "fa-star-o")),
    }), (subscribed.tag === 2) ? (" " + res.Subscribe) : ((subscribed.tag === 1) ? (" " + res.Subscribe) : (" " + res.Unsubscribe)));
}

function Dialog_toggleSubscriptionStars(subscribed, res, dispatch) {
    return react.createElement("i", {
        className: "fa fa-4x " + ((subscribed.tag === 2) ? "fa-star-half-o" : ((subscribed.tag === 1) ? "fa-star-o" : "fa-star")),
        onClick: (_arg1) => {
            dispatch(new Msg(7));
        },
    });
}

export function Dialog_render$0027(res, abbrechen, header, footer, content) {
    return react.createElement("div", {
        className: "modal fade in",
        tabIndex: -1,
        role: "dialog",
        style: {
            display: "block",
            paddingRight: "14px",
        },
    }, react.createElement("div", {
        className: "modal-dialog modal-lg",
    }, react.createElement("div", {
        className: "modal-content",
    }, react.createElement("div", {
        className: "modal-header",
    }, react.createElement("button", {
        type: "button",
        className: "close",
        onClick: abbrechen,
    }, "×"), header), react.createElement("div", {
        className: "modal-body",
    }, ...content), react.createElement("div", {
        className: "modal-footer",
    }, react.createElement(react.Fragment, {}, ...footer), react.createElement("button", {
        type: "button",
        className: "btn btn-info btn-sm",
        onClick: abbrechen,
    }, res.Schliessen)))));
}

export function Dialog_renderWithSubscription(res, abbrechen, header, content, eigenesProgramm, subscribed, dispatch) {
    if (eigenesProgramm) {
        return Dialog_render$0027(res, abbrechen, react.createElement("div", {
            className: "row",
        }, react.createElement("div", {
            className: "col-xs-10",
        }, header), react.createElement("div", {
            className: "col-xs-2 text-center",
        }, Dialog_toggleSubscriptionStars(subscribed, res, dispatch))), [Dialog_toggleSubscription(subscribed, res, dispatch)], content);
    }
    else {
        return Dialog_render$0027(res, abbrechen, header, [], content);
    }
}

export function Dialog_render(res, abbrechen, header, content) {
    return Dialog_render$0027(res, abbrechen, header, [], content);
}

export function AnmeldungAnfordern_render(res, url, dispatch) {
    let arg20;
    return Dialog_render(res, (_arg1) => {
        dispatch(new Msg(1));
    }, react.createElement("h3", {
        className: "modal-title",
    }, "Login required"), [res.LoginPlease1, react.createElement("a", {
        className: "btn btn-info ",
        href: (arg20 = window.location.href, toText(printf("%s?returnUrl=%s"))(url)(arg20)),
    }, res.Login), res.LoginPlease2]);
}

export function Beitrag_autoren(res, beitrag) {
    const letzterAutor = last(beitrag.Autoren);
    return map((autor) => react.createElement(react.Fragment, {}, react.createElement("span", {
        className: autor.Vortragender ? "Vortragender" : "",
    }, autor.Name), react.createElement("sup", {}, ...map((i) => int32ToString(i), autor.FirmenIndex)), (!equals(autor, letzterAutor)) ? ", " : Helpers_nothing), beitrag.Autoren);
}

export function Beitrag_firmen(beitrag) {
    return mapIndexed((i, firma) => react.createElement(react.Fragment, {}, int32ToString(i + 1), " ", firma.Name, (firma.Land === "") ? "" : (", " + firma.Land), react.createElement("br", {})), beitrag.Firmen);
}

export function Beitrag_head(res, beitrag, inOrtszeit) {
    return react.createElement("div", {
        className: "row",
    }, react.createElement("div", {
        className: "col-xs-10",
    }, ...ofSeq(delay(() => append(singleton(react.createElement("h3", {
        className: "modal-title",
    }, react.createElement("span", {
        className: "small",
    }, beitrag.Vortragsnummer))), delay(() => ((!(beitrag.Zeiten.tail == null)) ? singleton(react.createElement("div", {
        className: "row",
    }, react.createElement("div", {
        className: "col-xs-12 small",
    }, res.BeginntUm, " ", join(res.Und, map((t) => (t + res.UhrZeitKurz), zeitAusgeben(beitrag.Zeiten, res, inOrtszeit)))))) : empty())))))));
}

export function Beitrag_content(res, beitrag, manuskripte) {
    return ofArray([react.createElement("h4", {
        style: {
            marginTop: "0",
        },
    }, beitrag.Titel), react.createElement("p", {}, ...Beitrag_autoren(res, beitrag)), react.createElement("p", {}, ...Beitrag_firmen(beitrag)), react.createElement("div", {
        style: {
            fontSize: "large",
            fontFamily: "\u0027Droid Serif\u0027, \u0027Times New Roman\u0027, Serif",
            whiteSpace: "pre-wrap",
        },
    }, beitrag.Kurzfassung), defaultArg(map_1((m) => react.createElement("div", {
        style: {
            margin: "1em 0 0 0",
        },
    }, react.createElement("a", {
        target: "_blank",
        href: "/" + m.Url,
    }, react.createElement("i", {
        className: "fa fa-file-pdf-o fa-2x",
    }), " Download Paper")), tryFind(beitrag.Vortragsnummer, manuskripte)), Helpers_nothing)]);
}

export function Beitrag_render(beitrag, manuskripte, res, inOrtszeit, eigenesProgramm, istSubscribed, dispatch) {
    return Dialog_renderWithSubscription(res, (_arg1) => {
        dispatch(new Msg(11));
    }, Beitrag_head(res, beitrag, inOrtszeit), Beitrag_content(res, beitrag, manuskripte), eigenesProgramm, istSubscribed, dispatch);
}

export function Session_renderBeitrag(res, inOrtszeit, eigenesProgramm, testIfSubscribed, dispatch, beitrag) {
    let patternInput;
    const matchValue = [beitrag.SessionNr, beitrag.Uhrzeit];
    patternInput = ((matchValue[0] == null) ? (isNullOrWhiteSpace(matchValue[1]) ? [beitrag.Vortragsnummer, ""] : [zeitAusgeben$0027(beitrag.Zeiten, res, inOrtszeit), beitrag.Vortragsnummer]) : [beitrag.Vortragsnummer + " *", matchValue[0]]);
    const letzterAutor = last(beitrag.Autoren);
    return react.createElement("div", {
        className: "row calBeitrag" + (beitrag.Abgesagt ? " Abgesagt" : ""),
        onClick: (e) => {
            if (beitrag.Abgesagt) {
                e.preventDefault();
            }
            else {
                dispatch(new Msg(10, beitrag));
            }
        },
    }, react.createElement("div", {
        className: "col-sm-2",
    }, react.createElement("div", {}, react.createElement("span", {}, patternInput[0], subscriptionStars(eigenesProgramm, testIfSubscribed(beitrag.Vortragsnummer)))), react.createElement("p", {
        className: "calRoom",
    }, react.createElement("span", {
        className: "calRoom",
    }, patternInput[1]))), react.createElement("div", {
        className: "col-sm-10",
    }, react.createElement("h4", {
        style: {
            marginTop: "0",
        },
    }, beitrag.Titel), react.createElement("p", {}, ...Beitrag_autoren(res, beitrag)), react.createElement("p", {}, react.createElement("small", {}, ...Beitrag_firmen(beitrag)))));
}

export function Session_renderHead(raum, session, res) {
    let letzterLeiter;
    const raum_1 = defaultArg(session.AndererRaum, raum.Raum);
    return react.createElement("div", {
        className: "row",
    }, react.createElement("div", {
        className: "col-xs-10",
    }, react.createElement("h3", {
        className: "modal-title",
    }, defaultArg(map_1((k) => react.createElement("span", {
        className: "small",
    }, k), session["Kürzel"]), Helpers_nothing), react.createElement("br", {}), session.Bezeichnung), (session.Sitzungsleiter.tail == null) ? Helpers_nothing : react.createElement("div", {
        className: "row",
    }, react.createElement("div", {
        className: "col-xs-3 col-sm-2",
    }, react.createElement("small", {}, (length(session.Sitzungsleiter) > 1) ? res.SitzungsleitungPlural : res.Sitzungsleitung)), react.createElement("div", {
        className: "col-xs-9 col-sm-10 small",
    }, ...(letzterLeiter = last(session.Sitzungsleiter), map((leiter) => react.createElement(react.Fragment, {}, leiter.AnzeigeName, (!equals(leiter, letzterLeiter)) ? ", " : Helpers_nothing), session.Sitzungsleiter)))), react.createElement("div", {
        className: "row",
    }, react.createElement("div", {
        className: "col-xs-3 col-sm-2 small",
    }, res.Raum), react.createElement("div", {
        className: "col-xs-9 col-sm-10 small",
    }, raum_1))));
}

export function Session_html(text) {
    return react.createElement("div", {
        dangerouslySetInnerHTML: new DangerousHtml(text),
    });
}

export function Session_render(raum, session, beitr$00E4ge, res, inOrtszeit, eigenesProgramm, istSubscribed, testIfSubscribed, dispatch) {
    return Dialog_renderWithSubscription(res, (_arg1) => {
        dispatch(new Msg(6));
    }, Session_renderHead(raum, session, res), cons(Session_html(session.Beschreibung), map((beitrag) => Session_renderBeitrag(res, inOrtszeit, eigenesProgramm, testIfSubscribed, dispatch, beitrag), beitr$00E4ge)), eigenesProgramm, istSubscribed, dispatch);
}

export function Programm_renderHead(raum, programm, res) {
    const raum_1 = defaultArg(programm.AndererRaum, raum.Raum);
    return react.createElement("div", {
        className: "row",
    }, react.createElement("div", {
        className: "col-xs-10",
    }, react.createElement("h3", {
        className: "modal-title",
    }, defaultArg(map_1((k) => react.createElement("span", {
        className: "small",
    }, k), programm["Kürzel"]), Helpers_nothing), react.createElement("br", {}), programm.Bezeichnung), react.createElement("div", {
        className: "row",
    }, react.createElement("div", {
        className: "col-xs-3 small",
    }, res.Raum), react.createElement("div", {
        className: "col-xs-9 small",
    }, raum_1))));
}

export function Programm_render(raum, programm, res, dispatch) {
    return Dialog_render(res, (_arg1) => {
        dispatch(new Msg(9));
    }, Programm_renderHead(raum, programm, res), [react.createElement("div", {
        dangerouslySetInnerHTML: new DangerousHtml(programm.Beschreibung),
    })]);
}

export function TagesProgramm_renderProgramm$0027(programm, res, inOrtszeit) {
    return react.createElement(react.Fragment, {}, react.createElement("div", {
        className: "clearfix",
    }), react.createElement("div", {
        className: "row",
        style: {
            marginBottom: "5px",
            marginTop: "16px",
        },
    }, react.createElement("h5", {}, zeitAusgeben$0027(programm.Startzeiten, res, inOrtszeit)), defaultArg(map_1((k) => react.createElement("div", {
        className: "calNumber text-center",
    }, k), programm["Kürzel"]), Helpers_nothing), react.createElement("div", {
        className: " text-center ",
    }, programm.Bezeichnung)));
}

export function TagesProgramm_renderProgramm(raum, programm, res, inOrtszeit, dispatch) {
    const hatBeschreibung = !isNullOrWhiteSpace(programm.Beschreibung);
    return react.createElement("div", keyValueList([new HTMLAttr(65, "col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 "), hatBeschreibung ? (new DOMAttr(40, (_arg1) => {
        dispatch(new Msg(8, raum, programm));
    })) : (new DOMAttr(40, (value_1) => {
        void value_1;
    }))], 1), react.createElement("div", {
        className: hatBeschreibung ? "calSession" : "calProgramm",
        style: {
            padding: "16px",
        },
    }, react.createElement("div", {
        className: "row ",
    }, react.createElement("div", {
        className: "col-xs-2",
    }, zeitAusgeben$0027(programm.Startzeiten, res, inOrtszeit)), react.createElement("div", {
        className: "col-xs-10 ",
    }, defaultArg(map_1((k) => react.createElement("div", {
        className: "calNumber",
    }, k), programm["Kürzel"]), Helpers_nothing), react.createElement("div", {}, programm.Bezeichnung)))));
}

export function TagesProgramm_renderSession(raum, session, res, inOrtszeit, istSubscribed, dispatch) {
    return react.createElement("div", {
        className: "col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 ",
        onClick: (_arg1) => {
            dispatch(new Msg(5, raum, session));
        },
    }, react.createElement("div", {
        className: "calSession",
        style: {
            padding: "16px",
        },
    }, ...ofSeq(delay(() => {
        let matchValue;
        return append((matchValue = istSubscribed(session["Kürzel"]), (matchValue.tag === 2) ? singleton(react.createElement("i", {
            className: "fa fa-star-half-o pull-right",
        })) : ((matchValue.tag === 1) ? singleton(Helpers_nothing) : singleton(react.createElement("i", {
            className: "fa fa-star pull-right",
        })))), delay(() => singleton(react.createElement("div", {
            className: "row ",
        }, react.createElement("div", {
            className: "col-xs-2",
        }, zeitAusgeben$0027(session.Startzeiten, res, inOrtszeit)), react.createElement("div", {
            className: "col-xs-10 ",
        }, defaultArg(map_1((k) => react.createElement("div", {
            className: "calNumber",
        }, k), session["Kürzel"]), Helpers_nothing), react.createElement("div", {}, session.Bezeichnung))))));
    }))));
}

export function TagesProgramm_renderPause(res, pause) {
    const pause_1 = (pause === "Pause") ? res.Pause : pause;
    return react.createElement(react.Fragment, {}, react.createElement("div", {
        className: "clearfix",
    }), react.createElement("p", {
        className: "text-center",
        style: {
            margin: "0",
        },
    }, react.createElement("i", {
        style: {
            fontSize: "0.8em",
        },
    }, pause_1)));
}

export function TagesProgramm_render(res, inOrtszeit, istSubscribed, dispatch, tag) {
    const raum = head(tag["Räume"]);
    return react.createElement("div", {
        className: "container",
        id: "calGrid",
    }, react.createElement("section", {
        id: "programm",
    }, ...map((a) => {
        const matchValue = [a.Pause, tryFind(raum.Id, a.Programmpunkte)];
        if (matchValue[0] != null) {
            const pause = matchValue[0];
            return TagesProgramm_renderPause(res, pause);
        }
        else if (matchValue[1] != null) {
            if (matchValue[1].tag === 1) {
                const session = matchValue[1].fields[0];
                return TagesProgramm_renderSession(raum, session, res, inOrtszeit, istSubscribed, dispatch);
            }
            else {
                const punkt_1 = matchValue[1].fields[0];
                return TagesProgramm_renderProgramm(raum, punkt_1, res, inOrtszeit, dispatch);
            }
        }
        else {
            return Helpers_nothing;
        }
    }, tag.Achsen)));
}

export function TagMitR$00E4umen_renderProgramm(raum, programm, dispatch) {
    const hatBeschreibung = !isNullOrWhiteSpace(programm.Beschreibung);
    return react.createElement("div", keyValueList([new HTMLAttr(65, "col-md-3 "), hatBeschreibung ? (new DOMAttr(40, (_arg1) => {
        dispatch(new Msg(8, raum, programm));
    })) : (new DOMAttr(40, (value_1) => {
        void value_1;
    }))], 1), (!hatBeschreibung) ? react.createElement("div", {
        className: "calPunkt",
    }, defaultArg(map_1((k) => react.createElement("div", {
        className: "calNumber",
    }, k), programm["Kürzel"]), Helpers_nothing), react.createElement("div", {
        className: "calName box equal-height",
        style: {
            height: "20px",
        },
    }, programm.Bezeichnung), react.createElement("div", {
        className: "calRoom",
    }, defaultArg(programm.AndererRaum, raum.Raum))) : react.createElement("div", {
        className: "calSession",
    }, defaultArg(map_1((k_1) => react.createElement("div", {
        className: "calNumber",
    }, k_1), programm["Kürzel"]), Helpers_nothing), react.createElement("div", {
        className: "calName box equal-height",
        style: {
            height: "20px",
        },
    }, programm.Bezeichnung), react.createElement("div", {
        className: "calRoom",
    }, defaultArg(programm.AndererRaum, raum.Raum))));
}

export function TagMitR$00E4umen_renderSession(raum, session, istSubscribed, dispatch) {
    return react.createElement("div", {
        className: "col-md-3 ",
        onClick: (_arg1) => {
            dispatch(new Msg(5, raum, session));
        },
    }, ...ofSeq(delay(() => {
        let matchValue;
        return append((matchValue = istSubscribed(session["Kürzel"]), (matchValue.tag === 2) ? singleton(react.createElement("i", {
            className: "fa fa-star-half-o pull-right",
        })) : ((matchValue.tag === 1) ? singleton(Helpers_nothing) : singleton(react.createElement("i", {
            className: "fa fa-star pull-right",
        })))), delay(() => singleton(react.createElement("div", {
            className: "calSession",
        }, defaultArg(map_1((k) => react.createElement("div", {
            className: "calNumber",
        }, k), session["Kürzel"]), Helpers_nothing), react.createElement("div", {
            className: "calName box equal-height",
            style: {
                height: "20px",
            },
        }, session.Bezeichnung), react.createElement("div", {
            className: "calRoom",
        }, raum.Raum)))));
    })));
}

export function TagMitR$00E4umen_renderPunkt(istSubscribed, dispatch, raum, punkt) {
    if (punkt != null) {
        if (punkt.tag === 1) {
            const session = punkt.fields[0];
            return TagMitR$00E4umen_renderSession(raum, session, istSubscribed, dispatch);
        }
        else {
            const punkt_1 = punkt.fields[0];
            return TagMitR$00E4umen_renderProgramm(raum, punkt_1, dispatch);
        }
    }
    else {
        return react.createElement("div", {
            className: "col-md-3 ",
        });
    }
}

export function TagMitR$00E4umen_render(tag, res, istSubscribed, dispatch) {
    return react.createElement("div", {
        id: "calGrid",
        className: "container",
        style: {
            marginTop: "16px",
        },
    }, ...map((achse) => react.createElement("div", {
        className: "row",
    }, react.createElement("div", {
        className: "col-xs-1 zeit",
    }, react.createElement("span", {}, achse.Startzeit)), react.createElement("div", {
        className: "col-xs-11",
    }, react.createElement("div", {
        className: "row",
    }, defaultArg(map_1((p) => react.createElement("div", {
        className: "pause col-xs-12",
    }, react.createElement("span", {
        className: "calNumber",
    }, (p === "Pause") ? res.Pause : p)), achse.Pause), Helpers_nothing), react.createElement(react.Fragment, {}, ...map((raum) => TagMitR$00E4umen_renderPunkt(istSubscribed, dispatch, raum, tryFind(raum.Id, achse.Programmpunkte)), tag["Räume"]))))), tag.Achsen));
}

export function Thema_renderBeitrag(res, dispatch, beitrag) {
    const letzterAutor = last(beitrag.Autoren);
    let patternInput;
    const matchValue = [beitrag.SessionNr, beitrag.Uhrzeit];
    patternInput = ((matchValue[0] == null) ? (isNullOrWhiteSpace(matchValue[1]) ? [beitrag.Vortragsnummer, ""] : [matchValue[1], beitrag.Vortragsnummer]) : [beitrag.Vortragsnummer + " *", matchValue[0]]);
    return react.createElement("div", {
        className: "row calBeitrag",
        onClick: (e) => {
            dispatch(new Msg(10, beitrag));
        },
    }, react.createElement("div", {
        className: "col-sm-2",
    }, react.createElement("p", {}, react.createElement("span", {}, patternInput[0])), react.createElement("p", {
        className: "calRoom",
    }, react.createElement("span", {
        className: "calRoom",
    }, patternInput[1]), react.createElement("i", {
        className: "fa fa-star fa-lg",
        style: {
            display: "none",
        },
    }))), react.createElement("div", {
        className: "col-sm-10",
    }, react.createElement("h4", {
        style: {
            marginTop: "0",
        },
    }, beitrag.Titel), react.createElement("p", {}, ...Beitrag_autoren(res, beitrag)), react.createElement("p", {}, react.createElement("small", {}, ...Beitrag_firmen(beitrag)))));
}

export function Thema_renderHead(thema, poster) {
    let arg20, arg10;
    return react.createElement("div", {
        className: "row",
    }, react.createElement("div", {
        className: "col-xs-10",
    }, react.createElement("h3", {
        className: "modal-title",
    }, react.createElement("span", {
        className: "small",
    }, (arg20 = last(poster).Vortragsnummer, (arg10 = head(poster).Vortragsnummer, toText(printf("%s - %s"))(arg10)(arg20)))), react.createElement("br", {}), thema)));
}

export function Thema_render(thema, beitr$00E4ge, res, dispatch) {
    return Dialog_render(res, (_arg1) => {
        dispatch(new Msg(4));
    }, Thema_renderHead(thema, beitr$00E4ge), map((beitrag) => Thema_renderBeitrag(res, dispatch, beitrag), beitr$00E4ge));
}

export function Posters_renderThema(thema, poster, res, dispatch) {
    let arg20, arg10;
    return react.createElement("div", {
        className: "col-lg-3 col-md-4 col-sm-6",
    }, react.createElement("div", {
        className: "calSession",
        onClick: (_arg1) => {
            dispatch(new Msg(3, [thema, poster]));
        },
    }, react.createElement("div", {
        className: "calNumber",
    }, (arg20 = last(poster).Vortragsnummer, (arg10 = head(poster).Vortragsnummer, toText(printf("%s - %s"))(arg10)(arg20)))), react.createElement("div", {
        className: "cal-Name box equal-height",
    }, thema), react.createElement("div", {
        className: "calRoom",
    }, res.Posterbereich)));
}

export function Posters_render(poster, res, dispatch) {
    let props, _arg1;
    return react.createElement("div", {
        id: "calGrid",
        className: "container",
    }, (props = ofArray([new HTMLAttr(65, "row"), ["style", {
        marginTop: "16px",
    }]]), react.createElement("div", keyValueList(props, 1), ...(_arg1 = poster, (_arg1.tail != null) ? ((_arg1.tail.tail == null) ? map((beitrag) => Thema_renderBeitrag(res, dispatch, beitrag), _arg1.head[1]) : map((tupledArg) => {
        const thema = tupledArg[0];
        return Posters_renderThema(isNullOrWhiteSpace(thema) ? res.Verschiedenes : thema, tupledArg[1], res, dispatch);
    }, _arg1)) : map((tupledArg) => {
        const thema = tupledArg[0];
        return Posters_renderThema(isNullOrWhiteSpace(thema) ? res.Verschiedenes : thema, tupledArg[1], res, dispatch);
    }, _arg1)))));
}

export function RahmenprogrammPunkt_head(beitrag, res) {
    return react.createElement("div", {
        className: "row",
    }, react.createElement("div", {
        className: "col-xs-10",
    }, react.createElement("h3", {
        className: "modal-title",
    }, react.createElement("span", {
        className: "small",
    }, beitrag.Bezeichnung)), react.createElement("div", {
        className: "row",
    }, react.createElement("div", {
        className: "col-xs-12 small",
    }, res.BeginntUm, beitrag.Zeit), react.createElement("div", {
        className: "col-xs-12 small",
    }, res.Ort, beitrag.Raum))));
}

export function RahmenprogrammPunkt_content(beitrag) {
    return singleton_1(react.createElement("div", {
        dangerouslySetInnerHTML: new DangerousHtml(beitrag.Beschreibung),
    }));
}

export function RahmenprogrammPunkt_render(beitrag, res, dispatch) {
    return Dialog_render(res, (_arg1) => {
        dispatch(new Msg(13));
    }, RahmenprogrammPunkt_head(beitrag, res), RahmenprogrammPunkt_content(beitrag));
}

export function EigenesProgramm_tagKopf(text) {
    return react.createElement("div", {
        style: {
            marginTop: "30px",
        },
    }, react.createElement("h4", {
        className: "text-center",
    }, text), react.createElement("div", {
        className: "separator",
    }));
}

export function EigenesProgramm_userId() {
    const container = document.getElementById(fableModule.Platzhalter);
    return container.dataset["user"];
}

export function EigenesProgramm_render(termine, istAngemeldet, url, res, dispatch) {
    return react.createElement("div", {
        className: "container",
        style: {
            marginTop: "16px",
        },
    }, react.createElement(react.Fragment, {}, ...map((tupledArg) => react.createElement(react.Fragment, {}, EigenesProgramm_tagKopf(tupledArg[0]), react.createElement("div", {}, ...map((t_2) => {
        const props_12 = ofArray([new HTMLAttr(65, "row sc-element "), ["style", {
            padding: "14px 0",
        }]]);
        return react.createElement("div", keyValueList(props_12, 1), react.createElement("div", {
            className: "col-sm-1",
        }), react.createElement("div", {
            className: "col-sm-3",
        }, head(zeitAusgeben(singleton_1(t_2.Start), res, false)), "-", head(zeitAusgeben(singleton_1(t_2.End), res, false)), " " + res.UhrZeitKurz, react.createElement("br", {}), react.createElement("span", {
            className: "small",
        }, t_2.Name)), react.createElement("div", {
            className: "col-sm-8",
        }, react.createElement("h4", {
            style: {
                marginTop: 0,
                marginBottom: 4,
            },
        }, t_2.Description), t_2.Location));
    }, tupledArg[1]))), groupBy((t_1) => {
        const datum_1 = parse(t_1.Start);
        let dow;
        let copyOfStruct = create(year(datum_1), month(datum_1), day(datum_1));
        dow = dayOfWeek(copyOfStruct);
        const tag = res.Tage[dow];
        const arg30 = month(datum_1) | 0;
        const arg20 = day(datum_1) | 0;
        return toText(printf("%s, %02i.%02i."))(tag)(arg20)(arg30);
    }, sortBy((t) => t.Start, termine, {
        Compare: (x, y) => comparePrimitives(x, y),
    }), {
        Equals: (x_1, y_1) => (x_1 === y_1),
        GetHashCode: (x_1) => stringHash(x_1),
    }))), react.createElement("div", {
        style: {
            paddingTop: 24,
        },
    }, ...ofSeq(delay(() => append(singleton(res.EigenesProgrammHilfe), delay(() => append(singleton(react.createElement("br", {})), delay(() => {
        let arg20_1;
        return append(istAngemeldet ? singleton(res.EigenesProgrammAbrufen) : singleton(react.createElement(react.Fragment, {}, res.EigenedProgrammSync, react.createElement("a", {
            className: "btn btn-info ",
            href: (arg20_1 = window.location.href, toText(printf("%s?returnUrl=%s"))(url)(arg20_1)),
        }, res.Login), res.EigenedProgrammSync2)), delay(() => {
            let arg20_2, arg10_2;
            return istAngemeldet ? singleton(react.createElement("p", {
                style: {
                    marginTop: 12,
                },
            }, react.createElement("i", {
                className: "fa fa-calendar",
            }), " ", react.createElement("a", {
                href: (arg20_2 = EigenesProgramm_userId(), (arg10_2 = ((window.location.protocol === "https:") ? "s" : ""), toText(printf("webcal%s://tagung.dgzfp/desktopmodules/tagung/profile/calendar.aspx?tn=%s"))(arg10_2)(arg20_2))),
            }, "Meine Termine "), " mit Kalender-App (z.B. Outlook) verbinden.")) : empty();
        }));
    }))))))));
}

export function Rahmenprogramm_tag(datum) {
    const datum_1 = parse(datum);
    return create(year(datum_1), month(datum_1), day(datum_1));
}

export function Rahmenprogramm_tagCaption(res, datum) {
    const wochentag = res.Tage[dayOfWeek(datum)];
    const arg30 = month(datum) | 0;
    const arg20 = day(datum) | 0;
    return toText(printf("%s, %02i.%02i."))(wochentag)(arg20)(arg30);
}

export function Rahmenprogramm_tagKopf(text) {
    return react.createElement("div", {
        style: {
            marginTop: "30px",
        },
    }, react.createElement("h4", {
        className: "text-center",
    }, text), react.createElement("div", {
        className: "separator",
    }));
}

export function Rahmenprogramm_renderPunkt(res, dispatch, r) {
    return react.createElement("div", {
        className: "row sc-element ",
        style: {
            padding: "14px 0",
        },
    }, react.createElement("div", {
        className: "col-sm-1",
    }), react.createElement("div", {
        className: "col-sm-3",
    }, react.createElement("p", {}, r.Zeit, res.UhrZeitKurz), react.createElement("p", {
        className: "small",
    }, r.Raum)), react.createElement("div", {
        className: "col-sm-8",
    }, react.createElement("h4", {
        style: {
            marginTop: "0px",
        },
    }, r.Bezeichnung), isNullOrWhiteSpace(r.Beschreibung) ? Helpers_nothing : react.createElement("a", {
        className: "btn btn-default btn-sm",
        onClick: (_arg1) => {
            dispatch(new Msg(12, r));
        },
    }, res.WeitereInformationen)));
}

export function Rahmenprogramm_render(rahmenprogramm, res, dispatch) {
    const props_3 = ofArray([new HTMLAttr(99, "calGrid"), new HTMLAttr(65, "container"), ["style", {
        marginTop: "16px",
    }]]);
    return react.createElement("div", keyValueList(props_3, 1), ...collect((x_2) => x_2, map((tupledArg_1) => ofArray([Rahmenprogramm_tagKopf(Rahmenprogramm_tagCaption(res, tupledArg_1[0])), react.createElement("div", {}, ...map((r_1) => Rahmenprogramm_renderPunkt(res, dispatch, r_1), tupledArg_1[1]))]), sortBy((tupledArg) => tupledArg[0], groupBy((r) => Rahmenprogramm_tag(r.Startdatum), rahmenprogramm, {
        Equals: (x, y) => equals_1(x, y),
        GetHashCode: (x) => dateHash(x),
    }), {
        Compare: (x_1, y_1) => compare(x_1, y_1),
    }))));
}

export function renderProgramm(model, res, dispatch) {
    let tabs_3, tabs_2, tabs_1, tabs, t, matchValue, s_5, tag_14;
    const mehrereTage = length(model.Tage) > 1;
    const hatRahmenprogramm = !(model.Rahmenprogramm.tail == null);
    const hatPoster = !(model.Poster.tail == null);
    const tabs_4 = react.createElement("div", {
        className: "container",
    }, react.createElement("ul", {
        className: "nav nav-tabs",
    }, ...(tabs_3 = (tabs_2 = (tabs_1 = (tabs = map((tag_1) => {
        let tag, wochentag;
        return react.createElement("li", {
            role: "presentation",
            className: equals(model["Ausgewählt"], new Tab(0, tag_1)) ? "active" : "",
        }, react.createElement("a", {
            href: "#",
            onClick: (event) => {
                dispatch(new Msg(2, new Tab(0, tag_1)));
                event.preventDefault();
                event.stopPropagation();
            },
        }, (tag = tag_1, (wochentag = res.Tage[tag.Wochentag], defaultArg(map_1((a) => {
            const d_1 = parse(a.Datum);
            const arg30 = month(d_1) | 0;
            const arg20 = day(d_1) | 0;
            return toText(printf("%s, %02i.%02i."))(wochentag)(arg20)(arg30);
        }, tryHead(tag.Achsen)), wochentag)))));
    }, model.Tage), isEmpty(model.TabSessions) ? tabs : append_1(tabs, map((tupledArg) => {
        const k = tupledArg[0];
        return react.createElement("li", {
            role: "presentation",
            className: equals(model["Ausgewählt"], new Tab(2, k)) ? "active" : "",
        }, react.createElement("a", {
            href: "#",
            onClick: (event_1) => {
                dispatch(new Msg(2, new Tab(2, k)));
                event_1.preventDefault();
                event_1.stopPropagation();
            },
        }, k));
    }, toList(model.TabSessions)))), (model.Poster.tail == null) ? tabs_1 : append_1(tabs_1, singleton_1(react.createElement("li", {
        role: "presentation",
        className: equals(model["Ausgewählt"], new Tab(1)) ? "active" : "",
    }, react.createElement("a", {
        href: "#",
        onClick: (event_2) => {
            dispatch(new Msg(2, new Tab(1)));
            event_2.preventDefault();
            event_2.stopPropagation();
        },
    }, res.Poster))))), (model.Rahmenprogramm.tail == null) ? tabs_2 : append_1(tabs_2, singleton_1(react.createElement("li", {
        role: "presentation",
        className: equals(model["Ausgewählt"], new Tab(3)) ? "active" : "",
    }, react.createElement("a", {
        href: "#",
        onClick: (event_3) => {
            dispatch(new Msg(2, new Tab(3)));
            event_3.preventDefault();
            event_3.stopPropagation();
        },
    }, res.Rahmenprogramm))))), model.EigenesProgramm ? append_1(tabs_3, singleton_1(react.createElement("li", {
        role: "presentation",
        className: equals(model["Ausgewählt"], new Tab(4)) ? "active" : "",
    }, react.createElement("a", {
        href: "#",
        onClick: (event_4) => {
            dispatch(new Msg(2, new Tab(4)));
            event_4.preventDefault();
            event_4.stopPropagation();
        },
    }, res.EigenesProgramm)))) : tabs_3)));
    const content = react.createElement("div", {
        ref: (_arg1_1) => {
            equalHeight('#calGrid');;
        },
    }, (t = (matchValue = [model["Ausgewählt"], model.Poster, model.Rahmenprogramm], (matchValue[0] != null) ? ((matchValue[0].tag === 1) ? Posters_render(matchValue[1], res, dispatch) : ((matchValue[0].tag === 2) ? (s_5 = matchValue[0].fields[0], Posters_render(FSharpMap__get_Item(model.TabSessions, s_5), res, dispatch)) : ((matchValue[0].tag === 3) ? Rahmenprogramm_render(matchValue[2], res, dispatch) : ((matchValue[0].tag === 4) ? EigenesProgramm_render(model.Termine, model.IstAngemeldet, model.ProfileUrl, res, dispatch) : (tag_14 = matchValue[0].fields[0], (length(tag_14["Räume"]) === 1) ? TagesProgramm_render(res, model.ZeitenInOrtszeit, (arg00) => Model__IstSubscribed_2297AD2E(model, arg00), dispatch, tag_14) : TagMitR$00E4umen_render(tag_14, res, (arg00_1) => Model__IstSubscribed_2297AD2E(model, arg00_1), dispatch)))))) : Helpers_nothing), model.ZeitenInOrtszeit ? react.createElement("div", {}, t, react.createElement("p", {
        className: "text-center",
        style: {
            marginTop: "3em",
            fontSize: "0.7em",
        },
    }, ((res.AngabenInOrtszeit + " (") + currentTimeZone()) + ")")) : t));
    if ((mehrereTage ? true : hatRahmenprogramm) ? true : hatPoster) {
        return ofArray([tabs_4, content]);
    }
    else {
        return singleton_1(content);
    }
}

export function render(model, dispatch) {
    let modalOffen;
    const matchValue = [model.Session, model.Programm, model.Thema, model.Beitrag, model.RahmenprogrammPunkt];
    let pattern_matching_result;
    if (matchValue[0] == null) {
        if (matchValue[1] == null) {
            if (matchValue[2] == null) {
                if (matchValue[3] == null) {
                    if (matchValue[4] == null) {
                        pattern_matching_result = 0;
                    }
                    else {
                        pattern_matching_result = 1;
                    }
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            modalOffen = "";
            break;
        }
        case 1: {
            modalOffen = "modal-open";
            break;
        }
    }
    const res = (model.Sprache === "Englisch") ? Englisch : Deutsch;
    const istSubscribed = (arg00) => Model__IstSubscribed_2297AD2E(model, arg00);
    return react.createElement("div", {
        className: modalOffen,
    }, ...ofSeq(delay(() => append(singleton(defaultArg(map_1((tupledArg) => {
        const s = tupledArg[1];
        return Session_render(tupledArg[0], s, defaultArg(tryFind(s.Id, model["Beiträge"]), empty_1()), res, model.ZeitenInOrtszeit, model.EigenesProgramm, istSubscribed(s["Kürzel"]), istSubscribed, dispatch);
    }, model.Session), Helpers_nothing)), delay(() => append(singleton(defaultArg(map_1((tupledArg_1) => Programm_render(tupledArg_1[0], tupledArg_1[1], res, dispatch), model.Programm), Helpers_nothing)), delay(() => append(singleton(defaultArg(map_1((tupledArg_2) => Thema_render(tupledArg_2[0], tupledArg_2[1], res, dispatch), model.Thema), Helpers_nothing)), delay(() => append(singleton(defaultArg(map_1((b) => Beitrag_render(b, model.Manuskripte, res, model.ZeitenInOrtszeit, model.EigenesProgramm, istSubscribed(b.Vortragsnummer), dispatch), model.Beitrag), Helpers_nothing)), delay(() => append(singleton(defaultArg(map_1((p_1) => RahmenprogrammPunkt_render(p_1, res, dispatch), model.RahmenprogrammPunkt), Helpers_nothing)), delay(() => append(singleton(model.AnmeldungAnfordern ? AnmeldungAnfordern_render(res, model.ProfileUrl, dispatch) : Helpers_nothing), delay(() => renderProgramm(model, res, dispatch))))))))))))))));
}

